/**
 * Global Store
 *
 * Application-wide state (store code, locale, etc.)
 */

import { createPersistedStore } from './store.setup';
import { DEFAULT_REGION } from '../directories';
import type { GlobalStore } from './global-store.types';

/**
 * Global store with automatic IndexedDB persistence
 *
 * ✅ No manual SSR checks needed
 * ✅ Automatic persistence on client-side
 * ✅ Works as regular observable on server-side
 */
export const globalStore$ = createPersistedStore<GlobalStore>('global', {
    storeCode: 'default',
    locale: 'vi',
    currency: 'VND',
    isOnline: true,
    currentRegion: DEFAULT_REGION,
});
